<p-sidebar
  [(visible)]="showSidebar"
  position="right"
  styleClass="kl-sidebar"
  (onHide)="closeSidebar()"
>
  <div class="sidebar-header">
    <label>Baslik</label>
  </div>
  <tabset>
    <tab>
      <accordion>
        <accordion-group>
          <div accordion-heading class="clearfix">
            <i class="fal fa-globe"></i> {{ "language" | translate }}
          </div>
          <label for="language" style="display: none"></label>
          <select
            name="language"
            id="language"
            class="form-control form-control-sm"
            [(ngModel)]="language"
            (change)="selectLang(language)"
          >
            <option value="tr">{{ "lang_tr" | translate }}</option>
            <option value="en">{{ "lang_en" | translate }}</option>
            <option value="az">{{ "lang_az" | translate }}</option>
            <option value="ru">{{ "lang_ru" | translate }}</option>
            <option value="fa">{{ "lang_fa" | translate }}</option>
          </select>
        </accordion-group>
        <accordion-group>
          <div accordion-heading class="clearfix">
            <i class="fal fa-lock"></i> {{ "password" | translate }}
          </div>
          <form
            #changePassForm="ngForm"
            (ngSubmit)="
              changePassForm.invalid ? (errorShow = true) : changePassword()
            "
            novalidate
          >
            <div class="form-group">
              <label for="current_password">
                <small> {{ "current_password" | translate }}</small>
              </label>
              <input
                type="password"
                class="form-control form-control-sm"
                #current_password="ngModel"
                name="current_password"
                (change)="inputChange()"
                [ngClass]="
                  errorShow && current_password.invalid ? 'errorInput' : ''
                "
                [(ngModel)]="changePass.current_password"
                id="current_password"
                maxlength="10"
                required
              />
              <div
                *ngIf="errorShow && current_password.invalid"
                class="errorMessage"
              >
                {{ "important_area" | translate }}
              </div>
            </div>
            <div class="form-group">
              <label for="new_password">
                <small>{{ "new_password" | translate }}</small>
              </label>
              <input
                type="password"
                class="form-control form-control-sm"
                name="new_password"
                #new_password="ngModel"
                (change)="inputChange()"
                [ngClass]="
                  errorShow && new_password.invalid ? 'errorInput' : ''
                "
                [(ngModel)]="changePass.new_password"
                id="new_password"
                maxlength="50"
                required
              />
              <div
                *ngIf="errorShow && new_password.invalid"
                class="errorMessage"
              >
                Bu alanın doldurulması gereklidir
              </div>
            </div>
            <div class="form-group">
              <label for="new_password_confirmation">
                <small>{{ "new_password_confirmation" | translate }}</small>
              </label>
              <input
                type="password"
                class="form-control form-control-sm"
                name="new_password_confirmation"
                (change)="inputChange()"
                #new_password_confirmation="ngModel"
                [ngClass]="
                  errorShow && new_password_confirmation.invalid
                    ? 'errorInput'
                    : ''
                "
                [(ngModel)]="changePass.new_password_confirmation"
                id="new_password_confirmation"
                maxlength="50"
                required
              />
              <div
                *ngIf="errorShow && new_password_confirmation.invalid"
                class="errorMessage"
              >
                Bu alanın doldurulması gereklidir
              </div>
            </div>
            <button type="submit" class="btn btn-sm btn-greenish float-right">
              {{ "edit" | translate }}
            </button>
          </form>
          <div class="mt-3 position-relative" style="height: 35px">
            <kl-alert
              [message]="alertMessage"
              [show]="alertShow"
              [type]="alertType"
              (onClose)="alertShow = false"
            ></kl-alert>
          </div>
        </accordion-group>
      </accordion>
    </tab>
  </tabset>
</p-sidebar>

<!-- <app-aside [fixed]="true" [display]="false">
  <tabset>
    <tab>
      <ng-template tabHeading><i class="icon-settings"></i></ng-template>
      <div class="p-3">
        <h6><i class="fal fa-globe"></i> {{'language' | translate}}</h6>
        <select name="language"
                id="language"
                class="form-control form-control-sm ml-3"
                [(ngModel)]="language"
                (change)="selectLang(language)">
          <option value="tr">{{'lang_tr' | translate}}</option>
          <option value="en">{{'lang_en' | translate}}</option>
          <option value="az">{{'lang_az' | translate}}</option>
          <option value="ru">{{'lang_ru' | translate}}</option>
          <option value="fa">{{'lang_fa' | translate}}</option>
        </select>
        <hr>
        <h6><i class="fal fa-donate"></i> {{'exchange' | translate}}</h6>
        <a class="c-header-nav-link ml-3" (click)="openTab()"> {{'exchange_rates' | translate}}</a>
        <hr>
        <h6> <i class="fal fa-lock"></i> {{'password' | translate}}</h6>
        <form #changePassForm="ngForm" (ngSubmit)="changePassForm.invalid ? errorShow = true : changePassword()"
              novalidate class="ml-3">
          <div class="form-group">
            <label for="current_password">
              <small> {{'current_password' | translate}}</small>
            </label>
            <input type="password"
                   class="form-control form-control-sm"
                   #current_password="ngModel"
                   name="current_password"
                   (change)="inputChange()"
                   [ngClass]="errorShow && current_password.invalid ? 'errorInput' : ''"
                   [(ngModel)]="changePass.current_password"
                   id="current_password"
                   maxlength="50" required/>
            <div *ngIf="errorShow && current_password.invalid"
                 class="errorMessage">
              {{'important_area' | translate}}
            </div>
          </div>
          <div class="form-group">
            <label for="new_password">
              <small>{{'new_password' | translate}}</small>
            </label>
            <input type="password"
                   class="form-control form-control-sm"
                   name="new_password"
                   #new_password="ngModel"
                   (change)="inputChange()"
                   [ngClass]="errorShow && new_password.invalid ? 'errorInput' : ''"
                   [(ngModel)]="changePass.new_password"
                   id="new_password"
                   maxlength="50" required/>
            <div *ngIf="errorShow && new_password.invalid"
                 class="errorMessage">
              Bu alanın doldurulması gereklidir
            </div>
          </div>
          <div class="form-group">
            <label for="new_password_confirmation">
              <small>{{'new_password_confirmation' | translate}}</small>
            </label>
            <input type="password"
                   class="form-control form-control-sm"
                   name="new_password_confirmation"
                   (change)="inputChange()"
                   #new_password_confirmation="ngModel"
                   [ngClass]="errorShow && new_password_confirmation.invalid ? 'errorInput' : ''"
                   [(ngModel)]="changePass.new_password_confirmation"
                   id="new_password_confirmation"
                   maxlength="50" required/>
            <div *ngIf="errorShow && new_password_confirmation.invalid"
                 class="errorMessage">
              Bu alanın doldurulması gereklidir
            </div>
          </div>
          <button type="submit" class="btn btn-sm btn-greenish float-right">{{'edit' | translate}}</button>
        </form>
        <div class="mt-3 ml-3 position-relative">
          <kl-alert [message]="alertMessage" [show]="alertShow" [type]="alertType"
                    (onClose)="alertShow = false"></kl-alert>
        </div>
      </div>
    </tab>
  </tabset>
</app-aside> -->
